<ol class="academy-quiz">
  <li
    *ngFor="let q of questions; let qi = index; trackBy: trackQuestion"
    class="academy-quiz__question"
  >
    <fieldset>
      <legend class="academy-quiz__prompt">
        <span class="academy-quiz__number" *ngIf="questions.length > 1">{{ qi + 1 }}.</span>
        {{ q.question }}
      </legend>
      <div class="academy-quiz__options" role="radiogroup" [attr.aria-label]="q.question">
        <button
          *ngFor="let o of q.options; let oi = index"
          type="button"
          role="radio"
          class="academy-quiz__option"
          [attr.data-state]="optionState(qi, oi)"
          [attr.aria-checked]="optionState(qi, oi) !== 'idle'"
          [disabled]="(mode === 'exam' && submitted) || (mode === 'practice' && solved(qi))"
          (click)="pick(qi, oi)"
        >
          <span class="academy-quiz__mark" aria-hidden="true">
            <nb-icon *ngIf="optionState(qi, oi) === 'correct'" icon="checkmark-outline"></nb-icon>
            <nb-icon *ngIf="optionState(qi, oi) === 'wrong'" icon="close-outline"></nb-icon>
          </span>
          <span class="academy-quiz__label">{{ o }}</span>
        </button>
      </div>

      <p class="academy-quiz__feedback is-wrong" *ngIf="retry(qi)" role="status">
        {{ 'academy.quiz.retry' | translate }}
      </p>
      <p
        class="academy-quiz__feedback is-right"
        *ngIf="(mode === 'practice' && solved(qi)) || (mode === 'exam' && submitted && solved(qi))"
        role="status"
      >
        <strong>{{ 'academy.quiz.right' | translate }}</strong>
        <ng-container *ngIf="q.explanation"> {{ q.explanation }}</ng-container>
      </p>
      <p class="academy-quiz__feedback is-wrong" *ngIf="mode === 'exam' && submitted && !solved(qi)" role="status">
        <strong>{{ 'academy.quiz.wrong' | translate }}</strong>
        <ng-container *ngIf="q.explanation"> {{ q.explanation }}</ng-container>
      </p>
    </fieldset>
  </li>
</ol>

<div class="academy-quiz__submit" *ngIf="mode === 'exam' && !submitted">
  <span class="academy-quiz__count">
    {{ 'academy.quiz.answered' | translate: { done: answeredCount, total: questions.length } }}
  </span>
  <button nbButton status="primary" type="button" [disabled]="!allPicked" (click)="submit()">
    {{ 'academy.quiz.submit' | translate }}
  </button>
</div>
